import React, { useCallback, useEffect, useState } from 'react'

const RadioGroupPersonbilTransportbil = ({handleParams, params}) => {



	const getIsCarrier = useCallback(()=>{
		return params.get('isCarrier')
	},[params])

	const [state, setState] = useState(getIsCarrier());

	useEffect(()=>{
		const currentIsCarrier = getIsCarrier()
		if ( state !== currentIsCarrier) {
			const newParams = new URLSearchParams(params.toString());
			
			newParams.set('isCarrier', state)
			if(state === null){
				newParams.delete('isCarrier')
			}
			handleParams(newParams)
		}
	},[state])

	// useEffect( ()=> {
	// 	const newState = getIsCarrier();
	// 	if(state !== newState) {
	// 		setState(newState)
	// 	}
	// },[params])

	return (		

		<div className="btn-group">
			<input defaultChecked={ state === null } type="radio" name="type" id="person" />
			<label 
				htmlFor="person"
				className={state === null ? 'active': ''}
				onClick={()=>{
					setState(null)
				}}
				>Personbilar</label>
			<input defaultChecked={ state === 'true' } type="radio" name="type" id="transport" />
			<label 
				htmlFor="transport"
				className={state === 'true' ? 'active': ''}
				onClick={()=>{
					setState('true')
				}}
				>Transportbilar</label>
		</div>
	)
}

export default RadioGroupPersonbilTransportbil